export type CertificateType = "course" | "roadmap";

export type CertificateUrlOptions = {
    firstName?: string | null;
    lastName?: string | null;
    baseUrl?: string | null;
    courseName?: string | null;
    type?: CertificateType;
    date?: string | null;
    courseLength?: string | null;
    /** Certificate language (?lang=); the image/pdf routes fall back to en. */
    lang?: string | null;
};

function computeNameHash(firstName?: string | null, lastName?: string | null, courseName?: string | null): string {
    const input = `${firstName ?? ""}|${lastName ?? ""}|${courseName ?? ""}`;
    let h = 0;
    for (let i = 0; i < input.length; i++) {
        h = (h << 5) - h + input.charCodeAt(i);
        h |= 0;
    }
    return Math.abs(h).toString(36);
}

function buildSearch(options?: CertificateUrlOptions, includeCacheBust = true): string {
    const params = new URLSearchParams();
    if (includeCacheBust) {
        params.set("v", computeNameHash(options?.firstName, options?.lastName, options?.courseName));
    }
    if (options?.lang && options.lang !== "en") {
        params.set("lang", options.lang);
    }
    if (options?.type === "roadmap") {
        params.set("type", "roadmap");
        if (options.courseName) params.set("name", options.courseName);
        if (options.firstName) params.set("fn", options.firstName);
        if (options.lastName) params.set("ln", options.lastName);
        if (options.date) params.set("date", options.date);
        if (options.courseLength) params.set("cl", options.courseLength);
    }
    return params.toString();
}

export function getCertificateUrl(id: string, options?: CertificateUrlOptions): string {
    const base = options?.baseUrl ? `${options.baseUrl}/certificate/img/${id}.png` : `/certificate/img/${id}.png`;
    return `${base}?${buildSearch(options)}`;
}

export function getCertificatePdfUrl(id: string, options?: CertificateUrlOptions): string {
    const base = options?.baseUrl ? `${options.baseUrl}/certificate/pdf/${id}.pdf` : `/certificate/pdf/${id}.pdf`;
    return `${base}?${buildSearch(options)}`;
}

export function getCertificatePageUrl(id: string, options?: CertificateUrlOptions): string {
    const base = options?.baseUrl ? `${options.baseUrl}/certificate/${id}` : `/certificate/${id}`;
    const search = buildSearch(options, false);
    return search ? `${base}?${search}` : base;
}
